import {
  Badge,
  Button,
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@design-system';
import { EyeIcon } from 'lucide-react';

import { ROW_DEFINITIONS, useRowVisibilityStore } from '@/features/policies-comparison';

export function RowVisibilityToggle() {
  const { visibleRows, toggleRow } = useRowVisibilityStore();

  const hiddenCount = ROW_DEFINITIONS.filter(row => !visibleRows[row.id]).length;

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger>
        <Button
          size="sm"
          variant="outline"
          aria-label="Show/Hide Rows"
          className="relative"
        >
          <EyeIcon className="block sm:hidden" />
          <span className="hidden sm:block">Show/Hide Rows</span>
          {hiddenCount > 0 && (
            <Badge className="bg-primary border-primary text-primary-foreground size-4 rounded-full p-0 text-[10px]">
              {hiddenCount}
            </Badge>
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        {ROW_DEFINITIONS.map(row => (
          <DropdownMenuCheckboxItem
            key={row.id}
            checked={visibleRows[row.id]}
            onCheckedChange={() => toggleRow(row.id)}
            onSelect={e => e.preventDefault()}
          >
            {row.label}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
